export enum TranskodeBundleComponentType {
  Feature = "Feature",
  Trailer = "Trailer",
  Teaser = "Teaser",
  Bonus = "Bonus",
  MakingOf = "MakingOf",
  Artwork = "Artwork",
  Clip = "Clip",
  DubCard = "DubCard",
  Episode = "Episode",
  TextlessMaterial = "TextlessMaterial",
  RestorationCard = "RestorationCard",
}
